module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return (_vm.largeScreen) ? _vm._c('div', {
    staticClass: "scalebar",
    attrs: {
      "id": "gv-scalebar"
    }
  }, [_vm._c('el-select', {
    attrs: {
      "size": "mini",
      "placeholder": ""
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _vm._c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09c0a335!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scalebar.vue
// module id = 815
// module chunks = 39